import Api from '../Base'

class GetUserRequestedInfo extends Api {
  requestUrl = `/api/UserRequest/${this.getParams().id}`
}

export default GetUserRequestedInfo
